import { render } from "./AiVehicleInfo.vue?vue&type=template&id=0dbc6586&scoped=true"
import script from "./AiVehicleInfo.vue?vue&type=script&lang=js"
export * from "./AiVehicleInfo.vue?vue&type=script&lang=js"

import "./AiVehicleInfo.vue?vue&type=style&index=0&id=0dbc6586&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbc6586"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiVehicleInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dbc6586"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dbc6586', __exports__)) {
    api.reload('0dbc6586', __exports__)
  }
  
  module.hot.accept("./AiVehicleInfo.vue?vue&type=template&id=0dbc6586&scoped=true", () => {
    api.rerender('0dbc6586', render)
  })

}


export default __exports__